import { ShieldAlert } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { useToi } from '../../../lib/auth.js';
import { PageHeader } from '../../../ui/index.js';
import { Bat2fa } from '../components/Bat2fa.js';

/**
 * Màn **ép bật** xác thực hai bước.
 *
 * `CanDangNhap` thay toàn bộ nội dung app bằng màn này khi `/core/me` trả
 * `buocBat2fa` — tức: vai trò này bắt buộc, chưa bật, và môi trường đang ép.
 * Cùng một màn cũng mở được **tự nguyện** ở `/bat-2fa`.
 *
 * Không dựng `AppShell` quanh nó: còn thanh bên là còn đường bấm sang trang
 * khác, mà mọi trang khác lúc này đều trả 403 `CAN_2FA` — người dùng sẽ đi
 * vòng quanh những khung đỏ thay vì làm việc cần làm.
 */
export function TrangBat2fa({ batBuoc = false }: { batBuoc?: boolean }) {
  const toi = useToi();
  const dieuHuong = useNavigate();

  const ep = batBuoc || (toi.data?.buocBat2fa ?? false);

  return (
    <div className="min-h-dvh bg-nen px-4 py-10">
      <div className="@container/noi-dung mx-auto w-full max-w-[760px]">
        {ep ? (
          <div
            data-khoi="ep-bat-2fa"
            role="alert"
            className="mb-6 flex gap-3 rounded-the border border-warn-chu/20 bg-warn-nen p-4"
          >
            <ShieldAlert size={22} aria-hidden="true" className="shrink-0 text-warn-chu" />
            <div>
              <p className="text-co-ban font-semibold text-warn-chu">
                Vai trò của bạn phải bật xác thực hai bước trước khi dùng app
              </p>
              <p className="mt-1 text-co-ban text-chu-phu">
                Tài khoản của bạn thấy hoặc đổi được dữ liệu của cả công ty. Mật khẩu một mình không
                đủ: ai lấy được nó là vào được mọi thứ. Mất khoảng hai phút, làm một lần.
              </p>
            </div>
          </div>
        ) : (
          <PageHeader
            breadcrumb={['QUẢN TRỊ', 'Bảo mật']}
            title="Bật xác thực hai bước"
            description="Thêm một mã 6 số từ điện thoại vào mỗi lượt đăng nhập."
          />
        )}

        <section className="rounded-the border border-vien bg-be-mat p-6">
          <Bat2fa
            nhanXong={ep ? 'Vào app' : 'Về trang Tài khoản'}
            onXong={() => {
              /*
               * `me` đã được `useXacNhan2fa` cho nạp lại, nên lúc này
               * `buocBat2fa` đã là `false` và `CanDangNhap` cho đi qua. Điều
               * hướng chứ không `window.location.reload()`: giữ nguyên cache
               * của TanStack Query thay vì tải lại cả bundle.
               */
              void dieuHuong(ep ? '/' : '/tai-khoan', { replace: true });
            }}
          />
        </section>
      </div>
    </div>
  );
}
